import { File } from "react-feather"
import Image from "next/image" // Import the Image component from Next.js

const FilePreview = ({ name, url, isImage = false }) => {
  return (
    <div className="flex w-full items-center mb-2 last:mb-0">
      {isImage ? (
        <div style={{ position: 'relative', width: 50, height: 50, marginRight: "8px" }}>
          <Image
            src={url}
            alt={name}
            layout="fill" // This allows the image to scale responsively
            objectFit="cover" // Ensures the image covers the area without stretching
            style={{
              borderRadius: "5px",
            }}
          />
        </div>
      ) : (
        <File className="w-[50px] h-[50px] mr-2" />
      )}
      <span className="text-body-small text-gray-600">{name}</span>
    </div>
  )
}

export default FilePreview
